
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';



const PaymentsList = props => {
    const [showModal, setShowModal] = useState(false);
    const [activeId, setActiveId] = useState('');
    const timeoutIdRef = useRef(null);
    const paymentListRef = useRef(null);
    
    const handlePaymentRowClicked = (event) => {
        const data = event.detail?.data;

        if (!data) return;

        timeoutIdRef.current = setTimeout(() => {
            setShowModal(true);
            setActiveId(data.id);
        }, 100);
    };

    useEffect(() => {
        const paymentListElement = paymentListRef.current;
        if (paymentListElement) {
            paymentListElement.addEventListener('click-event', handlePaymentRowClicked);
        }

        return () => {
            if (paymentListElement) {
                paymentListElement.removeEventListener('click-event', handlePaymentRowClicked);
            }
            if (timeoutIdRef.current) {
                clearTimeout(timeoutIdRef.current);
            }
        };
    }, []); 
    

    const handleCloseModal = () => {
        setShowModal(false);
        setActiveId('');
    }






    
    
    return (
        <div className='coupon_table_wrapper px-0'>
            {
                props.access_token && (
                    <div className="list-component-wrapper">
                        <justifi-payments-list-filters/>
                        <justifi-payments-list
                            account-id={props.subAccountId}
                            auth-token={props.access_token}
                            ref={paymentListRef}
                        ></justifi-payments-list>
                    </div>

                )
            }


                <Modal
                    show={showModal}
                    animation={false}
                    dialogClassName="payment_modal"
                    size="lg"
                    centered
                >
                    <Modal.Body>
                        <span className="modal_close" onClick={handleCloseModal}><i className="icon-cross" /></span>

                        {
                            activeId ? (
                                <justifi-payment-details
                                    data-testid="justifi-payment-details"
                                    auth-token={props.access_token}
                                    payment-id={activeId} />
                            ) : ''
                        }
                        
                    </Modal.Body>
                </Modal>

            
        </div>
    )

}


const mapStateToProps = state => {
    let { userProfile } = state.user;
    let { campCode, subAccountId } = userProfile;

    return {
        campCode,
        subAccountId
    };
}


export default connect(mapStateToProps)(PaymentsList);
